module.exports = __webpack_public_path__ + "static/media/staff.f5ccd764.png";